import React, { useRef } from "react";
import emailjs from "@emailjs/browser";

import { MdOutlineEmail } from "react-icons/md";
import { BsTelegram } from "react-icons/bs";
import { BsTelephone } from "react-icons/bs";

import "./Contact.css";

function Contact() {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_jqhfuf3",
        "template_3b4m033",
        form.current,
        "DjvHudySlQRU8Vzpq"
      )
      .then(
        (result) => {
          alert("Message Successfully Sent");
        },
        (error) => {
          alert(`Something Went Wrong! Please try again`);
        }
      );
    e.target.reset();
  };
  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className="contact__option-icon" />
            <h4>Email</h4>
            <h5>aklilsolomon3@gmail.com</h5>
            <a href="mailto:aklilsolomon3@gmail.com">Send a message</a>
          </article>
          <article className="contact__option">
            <BsTelegram className="contact__option-icon" />
            <h4>Telegram</h4>
            <h5>Akuna444</h5>
            <a href="https://t.me/akuna444">Send a message</a>
          </article>
          <article className="contact__option">
            <BsTelephone className="contact__option-icon" />
            <h4>Call</h4>
            <h5>+251941067481</h5>
            <a href="tel:+251941067481">Call Me</a>
          </article>
        </div>
        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            required
          />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea
            name="message"
            rows="7"
            placeholder="Your Message"
            required
          />
          <button type="submit" className="btn btn-primary">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
}

export default Contact;
